var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"earnings-figures",on:{"click":function($event){return _vm.transClass($event)}}},[_c('OverviewCard'),(!_vm.isDeveloper)?_c('masking',{staticStyle:{"padding":"0 0 200px"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }